import { FlexRow, VerticalSpace } from '@framework/ui';
import { Card } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import * as React from 'react';
import { CommunicationSearchForm } from './CommunicationSearchForm';

interface ICommunicationToolbarProps {
  fieldsSize?: SizeType;
}

/**
 * Elenco delle comunicazioni con paginazione
 */
export function CommunicationToolbar(props: ICommunicationToolbarProps) {
  const { fieldsSize = 'middle' } = props;

  return (
    <div>
      <Card size="small">
        <FlexRow>
          <CommunicationSearchForm size={fieldsSize} />
        </FlexRow>
      </Card>

      <VerticalSpace />
    </div>
  );
}
